<nav id="sidebar" data-testid="sidebar" class="sidebar d-flex" [ngClass]="{ collapsed: isClosed() }">
  <div class="sidebar-content position-relative d-flex flex-column h-100 w-100">
    <a class="sidebar-brand logo" [routerLink]="brandLink()">
      <img class="navbar-brand-logo" src="/assets/logos/logo-black.svg" class="img-fluid my-2 px-5" alt="brightscrip logo" />
    </a>

    @if (loadingCount() === 0) {
      <app-loading-spinner [isLoading]="isLoading()" />
    }

    <ul
      class="sidebar-nav nav-links mb-1 p-0 separator-bottom"
      [ngClass]="{ 'flex-grow-1': pharmacies() === undefined && chains() === undefined }"
    >
      <ng-container *ngTemplateOutlet="links; context: { links: navLinks() }" />
    </ul>

    @if (pharmacies() !== undefined) {
      <div class="px-4 pt-2">
        <h5 class="listHeader d-flex" (click)="isPharmacySectionOpen.set(!isPharmacySectionOpen())">
          <div class="iconWrapper">
            <chitin-icon [icon]="isPharmacySectionOpen() ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'" />
          </div>
          <div>Pharmacies</div>
          @if (isLoading() && !isPharmacySectionOpen()) {
            <div class="ms-2 spinner-border spinner-border-sm" style="color: var(--color-text-muted); opacity: 0.8" role="status">
              <span class="sr-only">Loading pharmacies...</span>
            </div>
          }
        </h5>
        @if (pharmacySearchEnabled() && isPharmacySectionOpen()) {
          <input
            type="text"
            class="form-control form-control-sm d-block mt-2 mb-1"
            [(ngModel)]="pharmacySearch"
            placeholder="Search by NPI or Name"
          />
        }
      </div>

      @if (isPharmacySectionOpen() || isPharmacyOpen()) {
        @if (isLoading()) {
          <div class="mt-3 mb-2 flex-grow-1 separator-bottom">
            @for (item of placeHolderItems(); track $index) {
              <div class="placeholder-glow mb-1">
                <span class="placeholder placeholder-lg entityPlaceholder">L</span>
              </div>
            }
          </div>
        } @else {
          @if (filteredPharmacies().length > 0) {
            <ul
              class="sidebar-nav mt-1 mb-0 pb-1 pharmacies flex-grow-1 separator-bottom"
              [ngClass]="{ openPharmacyOnly: !isPharmacySectionOpen() && isPharmacyOpen() }"
              data-cy="pharmacySelect"
            >
              <ng-container *ngTemplateOutlet="links; context: { links: filteredPharmacies() }" />
            </ul>
          }
          @if (filteredPharmacies().length === 0) {
            <div class="ps-4 mt-3 flex-grow-1 separator-bottom">No pharmacies found.</div>
          }
        }
      } @else {
        <div class="mt-2 mb-1 separator-bottom"></div>
      }
    }

    @if (chains() !== undefined) {
      <div class="px-4 pt-2">
        <h5 class="listHeader d-flex" (click)="isChainSectionOpen.set(!isChainSectionOpen())">
          <div class="iconWrapper">
            <chitin-icon [icon]="isChainSectionOpen() ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'" />
          </div>
          <div>Pharmacy Groups</div>
          @if (isLoading() && !isChainSectionOpen()) {
            <div class="ms-2 spinner-border spinner-border-sm" style="color: var(--color-text-muted); opacity: 0.8" role="status">
              <span class="sr-only">Loading pharmacy groups...</span>
            </div>
          }
        </h5>
        @if (chainSearchEnabled() && isChainSectionOpen()) {
          <input
            type="text"
            class="form-control form-control-sm d-block mt-2 mb-1"
            [(ngModel)]="chainSearch"
            placeholder="Search by chain NPI or Name"
          />
        }
      </div>
      @if (isChainSectionOpen() || isChainOpen()) {
        @if (isLoading()) {
          <div class="mt-3 mb-2 flex-grow-1 separator-bottom">
            @for (item of placeHolderItems(); track $index) {
              <div class="placeholder-glow mb-1">
                <span class="placeholder placeholder-lg entityPlaceholder">L</span>
              </div>
            }
          </div>
        } @else {
          @if (filteredChains().length > 0) {
            <ul
              class="sidebar-nav mt-1 mb-0 pb-3 chains flex-grow-1"
              [ngClass]="{ openPharmacyOnly: !isChainSectionOpen() && isChainOpen() }"
              data-cy="chainSelect"
            >
              <ng-container *ngTemplateOutlet="links; context: { links: filteredChains() }" />
            </ul>
          }
          @if (filteredChains().length === 0) {
            <div class="ps-4 flex-grow-1">No pharmacy groups found.</div>
          }
        }
        <div class="flex-grow-1 separator-bottom"></div>
      } @else {
        <div class="mt-2 mb-1 separator-bottom"></div>
      }
      @if (!isChainSectionOpen() && !isLoading()) {
        <div class="flex-grow-1"></div>
      }
    }
    <ul class="sidebar-nav nav-links mb-0 p-0 sidebar-bottom-links">
      <ng-container *ngTemplateOutlet="links; context: { links: bottomLinks() }" />
    </ul>
    <app-theme-toggle class="sidebar-theme-toggle" />
  </div>
</nav>

<ng-template #links let-links="links">
  @for (link of links; track link; let i = $index) {
    @if (link.header === true) {
      <li class="sidebar-header row-rise" [style.--cl-row-i]="i">{{ link.label }}</li>
    } @else {
      <li class="sidebar-item row-rise" [style.--cl-row-i]="i" routerLinkActive="active">
        <a class="sidebar-link" [routerLink]="link.path" (click)="linkClicked()" data-cy="navItem" data-testid="navItem">
          <span class="iconWrapper"><i class="{{ link.icon }}"></i></span>
          <span class="align-middle">
            <span>{{ link.label }}</span>
            @if (link.subLabel) {
              <br />
              <span class="sidebar-link-info">{{ link.subLabel }}</span>
            }
          </span>
          @if (link.isNew) {
            <small>
              <span class="badge ms-1 align-middle badge-new"> New! </span>
            </small>
          }
          @if (link.isEarlyAccess) {
            <small>
              <span class="gBadge success xs ms-1 align-middle">Early Access</span>
            </small>
          }
          @if (link.messageIcon) {
            <i class="ms-2 {{ link.messageIcon }}" [ngbTooltip]="link.message"></i>
          }
        </a>
        <ng-container *ngTemplateOutlet="sublinks; context: { link }" />
      </li>
    }
  }
</ng-template>

<ng-template #sublinks let-link="link">
  <ul class="sidebar-dropdown list-unstyled collapse">
    @for (sublink of link.sublinks; track sublink) {
      <li class="sidebar-item" routerLinkActive="active">
        <a class="sidebar-link" [routerLink]="sublink.path" (click)="linkClicked()" data-cy="navItem">
          <span class="iconWrapper"><i class="{{ sublink.icon }}"></i></span>
          <span class="align-middle">{{ sublink.label }}</span>
          @if (sublink.isNew) {
            <small><span class="badge ms-1 align-middle badge-new">New!</span></small>
          }
          @if (sublink.isEarlyAccess) {
            <small>
              <span class="gBadge success xs ms-1 align-middle">Beta</span>
            </small>
          }
          @if (sublink.messageIcon) {
            <i class="ms-2 {{ sublink.messageIcon }}" [ngbTooltip]="sublink.message"></i>
          }
        </a>
      </li>
    }
  </ul>
</ng-template>
